import axios from "./axios";
import * as Requests from "./requests";

export const getCustomerInfoAPI = (token: string, id: string) => {
  return axios.get(Requests.customerURL(id), {
    headers: {
      token,
    },
    baseURL: process.env.REACT_APP_PICKUP_ENDPOINT,
  });
};
